import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/KristieRoth_Pet/subs.vtt';
import poster from '@/static/assets/reviews/KristieRoth_Pet/video.jpg';

export const KristieRoth: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Kristie',
  videoUrl: `${ASSETS_URL}/pet/KristieRoth_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
